import React, { FunctionComponent, SVGProps } from 'react';
import { useTheme } from 'styled-components';

export interface InstrumentalIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
  isInvertedTheme?: boolean;
}

export const InstrumentalIcon: FunctionComponent<InstrumentalIconProps> = ({
  className,
  isInvertedTheme,
  ...props
}) => {
  const theme = useTheme();

  const getBGColor = () => {
    if (isInvertedTheme) {
      return theme.colors.primary;
    }

    return theme.colors.secondary;
  };

  const getPathColor = () => {
    if (isInvertedTheme) {
      return theme.colors.secondary;
    }

    return theme.colors.primary;
  };

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      className={className || ''}
      {...props}
    >
      <circle fill={getBGColor()} cx="8" cy="8" r="8" />
      <path
        fill={getPathColor()}
        d="M10,10.19v1.31H6v-1.31h1.24V5.81h-1.24v-1.31h4v1.31h-1.24v4.39h1.24Z"
      />
    </svg>
  );
};

export default InstrumentalIcon;
